import { render, staticRenderFns } from "./referee-stats.vue?vue&type=template&id=5fe1a02c&scoped=true&"
import script from "./referee-stats.vue?vue&type=script&lang=js&"
export * from "./referee-stats.vue?vue&type=script&lang=js&"
import style0 from "./referee-stats.vue?vue&type=style&index=0&id=5fe1a02c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1a02c",
  null
  
)

component.options.__file = "referee-stats.vue"
export default component.exports